export const EXCLUDED_SKU_PREFIXES = Object.freeze(['HN', 'DH', 'ELEGENT', 'LP', 'WS-LP']);

const cleanSku = (value) => String(value ?? '').trim().toUpperCase();

export function isSkuExcludedByPrefix(value) {
  const sku = cleanSku(value);
  return Boolean(sku) && EXCLUDED_SKU_PREFIXES.some(prefix => sku.startsWith(prefix));
}

export function filterExcludedSkuRows(rows = [], skuField = 'sku') {
  return (rows || []).filter(row => !isSkuExcludedByPrefix(row?.[skuField]));
}
